import React from 'react';
import UsTodniKamgarStore from '../stores/UsTodniKamgarStore';
import { Modal } from 'react-bootstrap';
var axios = require('axios');
var constants = require("../constants/constants");

export default class BlackListShow extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            iskamgarDetails: false,
            isKamgarInfo: false,
            isEditAction: false,
            show: false,
            KamgarInformation: [],
            workerInfo: [],
            BlacklistedInfo: {},
            editKamgarData: null,
            CompanyId: CompanyId,
            fname: '',
        };
        this.getMukadamRecord = this.getMukadamRecord.bind(this);
        this.searchBlackListed = this.searchBlackListed.bind(this);
    }

    BlakListInformation() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_BLACKLISTED_DETAILS, {
            //  params: { CompanyId: user.TargetCompanyId, YearId: user.TargetYearId}
            params: { TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId, fname: '' }

        }).then(function (response) {
            currentComponent.setState({ workerInfo: response.data })
            //  console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    getMukadamRecord() {
        this.BlakListInformation();
    }

    componentWillMount() {
        this.BlakListInformation();
        UsTodniKamgarStore.addListener('MukadamRecord', this.getMukadamRecord);

    }

    componentWillUnmount() {
        UsTodniKamgarStore.removeListener('MukadamRecord', this.getMukadamRecord)
    }

    //Button method
    kamgarDetails(e) {
        this.setState({
            iskamgarDetails: true
        });
        this.props.history.push('/UsTodKamgaranchiMahiti')
    }

    searchBlackListed(AdharCardNo, BlockedBy) {
        let currentComponent = this;
        // var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.SEARCH_BALCKLISTED_NAME, {
            params: {
                AdharCardNo: AdharCardNo,
                BlockedBy: BlockedBy
            }
        })
            .then(function (response) {
                currentComponent.setState({ BlacklistedInfo: response.data })
                currentComponent.UserShowInformation()
                console.log(response.data)
            }).catch(function (error) {
                console.log(error);
            });
        this.setState({ show: true });
    }

    UserShowInformation() {
    }

    SearchKamgarMukadamName(fname) {
        let currentComponent = this;
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.SEARCH_KAMGAR_MUKADAM_NAME, {
            params: {
                TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId,
                fname: fname
            }
        })
            .then(function (response) {
                currentComponent.setState({ workerInfo: response.data })
            }).catch(function (error) {
                console.log(error);
            });
    }
    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        let currentComponent = this;
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '50px' }}>ब्लॅकलिस्ट बदल माहिती </b></h3>
                            <div><br />
                                <div class="form_row">
                                    <input type="text" class="form_input" style={{ 'margin-left': '100px', 'line-height': '26px' }} id="fname" name="fname" value={this.state.fname}
                                        onChange={(e) => this.handleInputChange(e)} placeholder="मुकादमाचे/कामगाराचे नाव शोधा.. " />
                                    <button type="button" className="btn btn-info btn  " onClick={() => this.SearchKamgarMukadamName(this.state.fname)}>शोधा </button>
                                </div><br /><br />
                                {
                                    (this.state.workerInfo !== null || this.state.workerInfo !== undefined) ?
                                        this.state.workerInfo.map(function (worker, index) {
                                            return (
                                                <tr>
                                                    <div style={{ padding: '5px 10px  0px 13px' }} className="card ">
                                                        <h4>  <b> नाव : <b style={{ 'color': '#FF0000' }}> {worker.fullname}</b></b>
                                                            <button type="button" className="btn btn-info btn  " style={{ 'margin-left': '240px' }} onClick={() => currentComponent.searchBlackListed(worker.AdharCardNo, worker.BlockedBy)}>Search</button>  </h4>
                                                    </div>
                                                </tr>
                                            )
                                        })
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={this.state.show} container={this} aria-labelledby="contained-modal-title">
                    <Modal.Body style={{ padding: "0px 0px" }}>
                        {this.UserShowInformation()}
                        <p style={{ padding: "0px 0px" }}><b>AddedByName</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.AddedByName}</b>
                        <p style={{ marginLeft: "10px" }}><b>AddedByUserContactNo</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.AddedByUserContactNo}</b>
                        <p><b>कामगाराचे नाव</b></p> <b style={{ 'color': '#3700B3' }}> {this.state.BlacklistedInfo.Fullname}</b>
                        <p><b>भूमिका</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.Post}</b>
                        <p><b>मोबाईल नंबर</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.Mobile}</b>
                        <p><b>कारखान्याचे नाव</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.CompanyName}</b>
                        <p><b>आधार नंबर</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.AdharCardNo}</b>
                        <p><b>ModifiedDate</b></p><b style={{ 'color': '#3700B3' }}>  {this.state.BlacklistedInfo.ModifiedDate}</b>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='btn-info btn' onClick={() => currentComponent.setState({ show: false })}><b style={{ 'color': '#000000' }}>बंद करा  </b></button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/BlackListShow.jsx